import { useForm, Controller } from "react-hook-form";
import MultiLanguageEditor from "./MultiLanguageEditor";
import { useLanguages } from "../hooks/use-languages";
import { Dialog, Button, InputText, Dropdown } from "primereact";
import { getMultiLngInitValue, validateMultiLanguageEditor } from "../util";
import { useToast } from "../hooks/use-toast";
import { getCommonParam } from "../config";
import { useEffect } from "react";
import axios from "axios";
import ShowOrUploadImg from "./ShowOrUploadImg";

const MultiLanguageDialog = ({
  title,
  isVisible,
  operationType,
  itemId,
  contents,
  initValue,
  onClose,
  table,
  inputTextComp = undefined,
  dropDownComp = undefined,
  hasImage = false,
  labelImg = undefined,
  label = ["Nome", "Valore"],
  itemToAdd = undefined,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting, isDirty },
  } = useForm();
  const { languages } = useLanguages();
  const { toastRef } = useToast();

  const getTableImg = () => {
    let tableImage = table;
    if (table === "aziendastory") tableImage = "aziendaStoria";
    if (table === "certificazione") tableImage = "certificato";
    if (table === "materie") tableImage = "materia";
    return tableImage;
  };

  const tableImage = getTableImg();

  const onCancel = () => {
    onClose();
  };

  const save = async (values) => {
    try {
      const apiCommonParam = getCommonParam();
      const { apiUrl, axiosConfig } = apiCommonParam;

      if (operationType === "U" || operationType === "D") {
        values.status = " ";
        await axios.post(`${apiUrl}${table}/salva/${itemId}`, values, axiosConfig);
      }
      if (operationType == "D") {
        values.status = "E";
        await axios.post(`${apiUrl}${table}/salva/${itemId}`, values, axiosConfig);
      }
      if (operationType == "A") {
        const dato = {
          ...itemToAdd,
          ...values,
        };
        await axios.post(`${apiUrl}${table}/aggiungi`, dato, axiosConfig);
      }
      toastRef.current.showToast("success", "Dati salvati correttamente", "");
    } catch (error) {
      console.error(error);
      toastRef.current.showToast("error", error, "");
    }
  };

  const onSubmit = async (data) => {
    try {
      if(table === "caratteristica"){
      const { nome, valore, ...rest } = data;
      await save({ ...rest, traduzione: [...nome, ...valore] });
      }else{
        const { nome, descrizione,  ...rest } = data;
        await save({ ...rest, traduzione: [...nome, ...descrizione] });
          
      }
      onClose();
    } catch (error) {
      console.error(error);
      onClose();
    }
  };

  useEffect(() => {
    if (!!contents && Object.keys(contents).length !== 0) {
      reset(initValue(contents, dropDownComp, inputTextComp));
    }
  }, [contents]);

  if (Object.keys(contents).length === 0 && operationType !== "A") {
    return null;
  }

  return (
    <div className="col-12">
      <Dialog
        header={title}
        closable={false}
        visible={isVisible}
        modal
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        style={{ width: "40vw" }}
        draggable={false}
        resizable={false}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          {inputTextComp && (
            <div className="flex flex-column w-full mb-3 px-2">
              <label htmlFor={inputTextComp.name} className="font-medium text-600">
                {inputTextComp.label}
              </label>
              <Controller
                name={inputTextComp.name}
                control={control}
                defaultValue={""}
                rules={{ required: "Campo obbligatorio" }}
                render={({ field, fieldState }) => (
                  <>
                    <InputText
                      {...field}
                      className="w-full flex"
                      type="text"
                      readOnly={operationType === "V" || operationType === "D" ? true : false}
                    />
                    {fieldState && fieldState?.error && (
                      <span className="text-xs font-bold text-red-500 ">{fieldState.error.message}</span>
                    )}
                  </>
                )}
              />
            </div>
          )}

          {dropDownComp && (
            <div className="flex flex-column w-full mb-3 px-2">
              <label htmlFor={dropDownComp.label} className="font-medium text-600">
                {dropDownComp.label}
              </label>
              <Controller
                name={dropDownComp.name}
                control={control}
                defaultValue={""}
                render={({ field }) => (
                  <Dropdown
                    {...field}
                    value={field.value}
                    onChange={(e) => setValue(dropDownComp.name, e.value)}
                    className="w-full flex"
                    inputId={field}
                    options={dropDownComp.options}
                    placeholder={dropDownComp.placeholder}
                    optionLabel={dropDownComp.optionLabel}
                    optionValue={dropDownComp.optionValue}
                    readOnly={operationType === "V" || operationType === "D" ? true : false}
                  />
                )}
              />
            </div>
          )}

                    
          <div className="col-12">
            <Controller
              name="nome"
              control={control}
              rules={{ validate: (values) => validateMultiLanguageEditor(values, languages) }}
              render={({ field, fieldState }) => (
                <MultiLanguageEditor
                  label={label[0]}
                  languages={languages}
                  className={"px-2"}
                  content={getMultiLngInitValue(table, "nome", languages, field.value)}
                  isReadOnly={operationType === "V" || operationType === "D" ? true : false}
                  setValue={setValue}
                  fieldName={"nome"}
                  isAddItem={operationType === "A"}
                  error={fieldState.error ?? undefined}
                />
              )}
            />
          </div>

          {(table!="caratteristica"?<div className="col-12">
            <Controller
              name="descrizione"
              control={control}
              rules={{ validate: (values) => validateMultiLanguageEditor(values, languages) }}
              render={({ field, fieldState }) => (
                <MultiLanguageEditor
                  label={label[1]}
                  languages={languages}
                  className={"px-2"}
                  content={getMultiLngInitValue(table, "descrizione", languages, field.value)}
                  isReadOnly={operationType === "V" || operationType === "D" ? true : false}
                  setValue={setValue}
                  fieldName={"descrizione"}
                  isAddItem={operationType === "A"}
                  error={fieldState.error ?? undefined}
                  type={label[1].toLowerCase() === "descrizione" ? "text-area" : "input-text"}
                />
              )}
            />
          </div>:"")}


          
          {(table=="caratteristica"?<div className="col-12">
            <Controller
              name="valore"
              control={control}
              rules={{ validate: (values) => validateMultiLanguageEditor(values, languages) }}
              render={({ field, fieldState }) => (
                <MultiLanguageEditor
                  label={label[1]}
                  languages={languages}
                  className={"px-2"}
                  content={getMultiLngInitValue(table, "valore", languages, field.value)}
                  isReadOnly={operationType === "V" || operationType === "D" ? true : false}
                  setValue={setValue}
                  fieldName={"valore"}
                  isAddItem={operationType === "A"}
                  error={fieldState.error ?? undefined}
                  type={label[1].toLowerCase() === "descrizione" ? "text-area" : "input-text"}
                />
              )}
            />
          </div>:"")}

          {hasImage && operationType !== "A" ? (
            <div className="px-2 col-12">
              <ShowOrUploadImg
                hasImage={contents.hasImage}
                operationType={operationType}
                aziendaid={contents.aziendaid}
                itemId={itemId}
                label={labelImg}
                table={tableImage}
              />
            </div>
          ) : null}

          <footer className="flex flex-col">
            {(operationType === "U" || operationType === "A") && (
              <div className="flex flex-row gap-2 mt-4">
                <Button
                  label="Salva"
                  className="ml-3 p-button-outlined font-bold pi"
                  type="submit"
                  icon="pi pi-save"
                  disabled={isSubmitting}
                  loading={isSubmitting}
                />
                <Button
                  type="button"
                  onClick={onCancel}
                  label="Annulla"
                  className="ml-3 p-button-outlined font-bold pi"
                  icon="pi pi-times"
                  disabled={isSubmitting}
                />
              </div>
            )}
            {operationType === "D" && (
              <div className="flex flex-row gap-2 mt-4">
                <Button
                  label="Elimina"
                  className="ml-3 p-button-outlined p-button-danger"
                  type="submit"
                  icon="pi pi-trash"
                  disabled={isSubmitting}
                  loading={isSubmitting}
                />
                <Button
                  type="button"
                  onClick={onCancel}
                  label="Annulla"
                  className="ml-3 p-button-outlined font-bold pi"
                  icon="pi pi-times"
                  disabled={isSubmitting}
                />
              </div>
            )}
            {operationType === "V" && (
              <div className="flex flex-row gap-2 mt-4">
                <Button
                  label="Indietro"
                  className="ml-3 p-button-outlined "
                  type="button"
                  onClick={onClose}
                  icon="pi pi-step-backward-alt"
                />
              </div>
            )}
          </footer>
        </form>
      </Dialog>
    </div>
  );
};

export default MultiLanguageDialog;
